import React, { FunctionComponent } from 'react';

import { Grid } from '@material-ui/core';
import styles from './MainFilter.module.scss';
import SelectInput from '../Form/Inputs/SelectInput';
import TextInput from '../Form/Inputs/TextInput';
import DatePicker from '../Form/Inputs/DatePicker';
import { SubmitIcon, ResetIcon } from 'app/assets/images/icons';
import ReactSelectAutocomplete from '../Form/Inputs/ReactSelectAutocomplete';

const inputTypes = ['text', 'autocomplete', 'select', 'datepicker'];
export type Input = {
  type: 'text' | 'autocomplete' | 'select' | 'datepicker';
  placeholder: string;
  options?: any;
  isMulti?: boolean;
  moduleName?: string;
  isDimmed?: boolean;
  onChange: any;
  icon?: JSX.Element;
  value: any;
  size: 'large' | 'small' | 'medium' | 'none';
  maxDate?: any;
  minDate?: any;
  customFilters?: any;
  resetMulti?: boolean;
  yearsOnly?: boolean;
  useLabel?: boolean;
  isDelete?: boolean;
};
interface Props {
  inputs: Input[];
  onSubmit: () => void;
  onReset: () => void;
  isLoading?: boolean;
  removeFilterMr?: boolean;
  extraPaddingTop?: boolean;
}

const inputsMap: any = {
  text: TextInput,
  datepicker: DatePicker,
  select: SelectInput,
  autocomplete: ReactSelectAutocomplete,
};

const renderInput = (input: Input) => {
  const Input = inputsMap[input.type];
  if (inputsMap[input.type]) {
    return input.isDelete ? (
      <></>
    ) : input.isDimmed ? (
      <div className={styles.DimmedInput}>
        <Input {...input} />
      </div>
    ) : (
      <Input {...input} />
    );
  }
  return;
};

const MainFilter: FunctionComponent<Props> = ({
  inputs,
  onSubmit,
  onReset,
  isLoading,
  removeFilterMr,
  extraPaddingTop,
}) => {
  const curserStyle = { cursor: isLoading ? 'no-drop' : 'pointer' };
  const handleSubmit = () => onSubmit?.();
  const handleReset = () => onReset?.();

  return (
    <form
      id="mainFilter"
      data-testid="main-filter-holder"
      className={`${styles.MainFilter} ${
        removeFilterMr ? styles.removeMR : ''
      } ${extraPaddingTop ? styles.extraPaddingTop : ''}`}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
      onReset={(e) => {
        e.preventDefault();
        onReset?.();
      }}
    >
      <div className={styles.Inputs} id="mainFilter-inputs">
        {/* <Grid container spacing={4}> */}
        {inputs?.map((input, index) => {
          if (!inputTypes.includes(input.type) || input.size === 'none') return;
          return (
            <div
              key={index}
              data-size={input.size}
              data-testid="mainFilters__Input"
            >
              {renderInput(input)}
            </div>
          );
        })}
        {/* </Grid> */}
      </div>
      <Grid
        className={styles.Controls}
        id="mainFilter-controls"
        data-testid="mainFilter-controls-testid"
      >
        <button
          disabled={isLoading}
          onClick={handleSubmit}
          type="submit"
          style={curserStyle}
        >
          <SubmitIcon />
        </button>
        <button
          onClick={handleReset}
          disabled={isLoading}
          type="reset"
          style={curserStyle}
        >
          <ResetIcon />
        </button>
      </Grid>
    </form>
  );
};

export default MainFilter;
